/* global jQuery */

export default function SUsShortcodes () {
  /*! <fs__only> */
  jQuery(function ($) {
    $('body:not(.su-s-shortcodes-loaded)').on('click', '.sue--clickable', function (
      e
    ) {
      if ($(this).data('target') === 'self') {
        document.location.href = $(this).data('url')
      } else {
        window.open($(this).data('url'))
      }
    })

    jQuery('body').addClass('su-s-shortcodes-loaded')
  })
  /*! </fs__only> */
}
